import React from "react";
import PropTypes from "prop-types";

export default (WrappedComponent) => {
  const hocComponent = ({ ...props }) => (
    <div className="w-full flex items-center mb-5 px-5">
      <WrappedComponent {...props} />
      <label className="text-lg w-40 text-right ">{props.label}</label>
    </div>
  );

  hocComponent.propTypes = {};

  return hocComponent;
};
